import { render } from "./chat-chips.vue?vue&type=template&id=01b61bbb"
import script from "./chat-chips.vue?vue&type=script&lang=js"
export * from "./chat-chips.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__